module.exports = __webpack_public_path__ + "assets/607808ee335a962bdfa989bbfd5e8c57.woff2";


//////////////////
// WEBPACK FOOTER
// ../~/@fontsource/roboto/files/roboto-cyrillic-ext-300-normal.woff2
// module id = 2622
// module chunks = 121